/** Stable per-question option order. Keep existing IDs/content when changing a bank. */
export const questionChoices = (key: string, correct: string, wrong: string[]) => {
  const options = [correct, ...wrong];
  let seed = 2166136261;
  for (const char of key) seed = Math.imul(seed ^ char.charCodeAt(0), 16777619);
  for (let i = options.length - 1; i > 0; i--) {
    seed ^= seed << 13; seed ^= seed >>> 17; seed ^= seed << 5;
    const other = (seed >>> 0) % (i + 1);
    [options[i], options[other]] = [options[other], options[i]];
  }
  return { options, answer: options.indexOf(correct) };
};
